module.exports = __webpack_public_path__ + "static/media/checkBoxActive.1e7afa28.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/checkBoxActive.svg
// module id = 1208
// module chunks = 3